import React, { memo } from "react";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { DashboardSubTypography } from "@assets/Typography";
import { IncCalender01 } from "@assets/imglink";
import images from "@app/images";
import { DefaultAvatar } from "@assets/avatar";
import MenuCaseView from "./MenuCaseView";

const DashboardHeaderLeft = memo(
  ({ onPopup, onClick, adData, advertiserCheck, adCheck }) => {
    const { ad, advertiser, img, imgName } = adData.target;
    return (
      <>
        <Grid container>
          <DefaultAvatar
            alt="캘린더아이콘"
            src={IncCalender01}
            width={80}
            height={80}
          />
          <Grid sx={{ pl: 2.5, flexGrow: 1, pr: 5.5 }}>
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              sx={{ height: 42 }}
            >
              <DashboardSubTypography text={"원하는 상품만 볼 수 있어요"} />
              <Typography
                variant="h3"
                component="div"
                fontWeight={500}
                sx={{ display: "flex", cursor: "pointer" }}
                onClick={onPopup}
              >
                <Avatar
                  sx={{
                    width: 24,
                    height: 24,
                    bgcolor: "grey.500",
                    mr: 1,
                  }}
                >
                  <Typography
                    textAlign="center"
                    variant="body"
                    fontWeight={500}
                    color={"white"}
                  >
                    ?
                  </Typography>
                </Avatar>
                <Typography variant="body" color={"#424242"}>
                  미리보기
                </Typography>
              </Typography>
            </Grid>
            <Grid container sx={{ mt: 1 }}>
              <Grid
                container
                justifyContent="space-around"
                alignItems="center"
                sx={{
                  flexGrow: 1,
                  height: 42,
                  pl: 1.5,
                  pr: 1.5,
                  bgcolor: "grey.400",
                  borderRadius: "10px",
                  cursor: "pointer",
                }}
                onClick={onClick}
              >
                <MenuCaseView
                  value={advertiser}
                  adType="advertiser"
                  text="광고주 전체"
                  adFunc={advertiserCheck}
                  cut={6}
                />
                <img src={images.icn_arrowLeft.default} alt=">" />
                <MenuCaseView
                  value={ad}
                  adType="ad"
                  text="광고상품 전체"
                  adFunc={adCheck}
                  cut={6}
                />
                <img src={images.icn_arrowLeft.default} alt=">" />
                <MenuCaseView
                  value={img}
                  adType="img"
                  text="이미지 전체"
                  imgName={imgName}
                  cut={8}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  }
);

export default DashboardHeaderLeft;
